import axios from 'axios';
import { getData, putData } from './index';
import {
  ERROR_USER, GET_GIF, GET_TOOLS, GET_METEO, GET_CONGRESS, USER_AUTH,
} from './types';

export async function getToolsAction(dispatch, user) {
  const url = '/tool';
  let toolsList;
  const userTools = user.tools?.map((t) => t.tool);
  const { division } = user;
  await getData(ERROR_USER, url, dispatch, true).then((response) => {
    toolsList = response.tools
      .filter((t) => t._id !== '6374e80d96463a6463ea7bd2')
      .filter((t) => {
        if (division.find((d) => t.division.find((td) => td === d))) {
          return t;
        }
        if (userTools?.find((id) => id === t._id)) {
          return t;
        }
        return null;
      });
  });
  let types;
  await getData(ERROR_USER, `${url}/list/type`, dispatch, true).then((response) => {
    types = response.types;
  });
  dispatch({
    type: GET_TOOLS,
    payload: { toolsList, types },
  });
}

const GIF_CACHE_PREFIX = 'majee_gif_day_';
const GIF_LAST_CACHE_KEY = 'majee_gif_last';

function getCachedGif(keyword) {
  return localStorage.getItem(`${GIF_CACHE_PREFIX}${keyword}`) || localStorage.getItem(GIF_LAST_CACHE_KEY);
}

function cacheGif(keyword, gifUrl) {
  localStorage.setItem(`${GIF_CACHE_PREFIX}${keyword}`, gifUrl);
  localStorage.setItem(GIF_LAST_CACHE_KEY, gifUrl);
}

export async function getGifAction(dispatch, keyword) {
  const cachedGif = getCachedGif(keyword);
  if (cachedGif) {
    dispatch({
      type: GET_GIF,
      payload: cachedGif,
    });
    return;
  }

  const giphyURL = `https://api.giphy.com/v1/gifs/random?api_key=0UTRbFtkMxAplrohufYco5IY74U8hOes&tag=${encodeURIComponent(keyword)}&rating=pg-13`;

  try {
    const res = await axios.get(giphyURL);
    const status = res?.data?.meta?.status;
    const gif = res?.data?.data?.images?.original?.url;

    if (status === 200 && gif) {
      cacheGif(keyword, gif);
      dispatch({
        type: GET_GIF,
        payload: gif,
      });
      return;
    }

    const fallbackGif = localStorage.getItem(GIF_LAST_CACHE_KEY);
    if (fallbackGif) {
      dispatch({
        type: GET_GIF,
        payload: fallbackGif,
      });
    }
  } catch (error) {
    const fallbackGif = localStorage.getItem(GIF_LAST_CACHE_KEY);
    if (fallbackGif) {
      dispatch({
        type: GET_GIF,
        payload: fallbackGif,
      });
    }
  }
}

export async function getMeteoAction(dispatch) {
  navigator.geolocation.getCurrentPosition(async (pos) => {
    const { latitude, longitude } = pos.coords;

    const url = `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current_weather=true`;
    const weatherData = await axios.get(url, {});
    const weather = weatherData?.data;
    const mapUrl = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=fr"`;
    const mapData = await axios.get(mapUrl, {});
    const data = {};
    const code = weather?.current_weather?.weathercode;
    if (code === 0) {
      data.icon = 'clear';
      data.message = 'Ciel clair';
    }
    if (code >= 1 && code <= 3) {
      data.icon = 'cloudy';
      data.message = 'Partielement nuageux';
    }
    if (code >= 45 && code <= 57) {
      data.icon = 'showers';
      data.message = 'Averses';
    }
    if (code >= 61 && code <= 94) {
      data.icon = 'rain';
      data.message = 'Pluie';
    }
    if (code >= 95 && code <= 99) {
      data.icon = 'storm';
      data.message = 'Orage';
    }
    data.temperature = weather.current_weather.temperature;
    data.city = mapData.data.city;
    dispatch({
      type: GET_METEO,
      payload: data,
    });
  });
}

export async function getCongressAction(dispatch) {
  const url = '/congress';
  let congress;
  await getData(ERROR_USER, url, dispatch, true).then((response) => {
    congress = response.congress
      .filter((t) => t?.endDate && new Date(t.endDate) > new Date());
  });
  dispatch({
    type: GET_CONGRESS,
    payload: congress,
  });
}

export { getNewsAction } from './newsActions';

export async function putFavoritesAction(
  dispatch,
  data,
) {
  const url = '/profile/favorite';
  const promise = await putData(USER_AUTH, ERROR_USER, url, dispatch, data, true)
    .then((response) => {
      console.log(response);
      dispatch({
        type: USER_AUTH,
        payload: response.user,
      });
    });
  return promise;
}
